// 공용 카드.
// 흰 표면 + 부드러운 토큰 그림자 + 라운드. 목록/상세/안내 블록의 기본 컨테이너.
// padding 토글과 임의 엘리먼트(as)로의 변형을 지원해 li/section 등으로도 쓸 수 있다.

import type { ElementType, ReactNode } from "react";
import { cn } from "./cn.ts";

interface CardProps {
  as?: ElementType;
  padded?: boolean;
  className?: string;
  children: ReactNode;
}

// 흰 표면 + 토큰 그림자 + 라운드의 공용 컨테이너. as 로 li/section 등으로 변형 가능.
export default function Card({
  as: Tag = "div",
  padded = true,
  className,
  children,
}: CardProps) {
  return (
    <Tag
      className={cn(
        "rounded-lg bg-surface shadow-card",
        padded && "p-4",
        className,
      )}
    >
      {children}
    </Tag>
  );
}
